import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import classes from './Swatch.styles.less';
export default function Swatch({ className, value, ...others }) {
    return (_jsx("button", { type: "button", className: cx(classes.swatch, className), style: { backgroundColor: value }, ...others }));
}
